import * as React from 'react';

interface OwnProps {
	address: {
		street: Nullable<string>;
		city: Nullable<string>;
		stateAbbreviation: Nullable<string>;
		state: Nullable<string>;
		postalCode: Nullable<string>;
		notes: Nullable<string>;
	};
}

type Props = OwnProps;

const _getAddressPostalLocation = (address: OwnProps['address']): string => {
	return `${address.city ?? ''} ${address.state ?? ''} ${address.postalCode ?? ''}`.trim();
};

const AddressCell: React.FC<Props> = ({ address }) => (
	<div>
		<div className="cell-main-info">{_getAddressPostalLocation(address)}</div>
		<div className="cell-additional-info">{address.street ?? '-'}</div>
		<div className="cell-additional-info">{address.notes ?? '-'}</div>
	</div>
);

export default AddressCell;
